import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './components/Home';
import { LoginFans } from './components/LoginFans';
import { LoginJudge } from './components/LoginJudge';
import { FinishSignUp } from './components/FinishSignUp';
import { AuthProvider } from './components/AuthContext';
import { VoteFans } from './components/VoteFans';
import { VoteJudge } from './components/VoteJudge';
import { VoteFansThankYou } from './components/VoteFansThankYou';
import { DisplayResults } from './components/DisplayResults';
import './styles.css'

function App() {

  return (
    <AuthProvider>
        <BrowserRouter>
            <Routes>
                
                <Route path="/" element={<Home/>}/>
                <Route path="/login-fans" element={<LoginFans/>}/>
                <Route path="/login-judge" element={<LoginJudge/>}/>

                <Route path="/finish-signup" element={<FinishSignUp/>}/>

                <Route path='/vote-fans' element={<VoteFans/>}/>

                <Route path='/vote-fans-thank-you' element={<VoteFansThankYou/>}/>

                <Route path='/vote-judge' element={<VoteJudge/>}/>

                <Route path='/display-results' element={<DisplayResults/>}/>

            </Routes>
        </BrowserRouter>
    </AuthProvider>

  )

  /*return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>+
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );*/
}

export default App;
